import _defineProperty2 from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _MediaGridPositons, _ContentGridPositions, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14;
var _excluded = ["palette", "textColor", "backgroundColor"],
  _excluded2 = ["layout"],
  _excluded3 = ["layout"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import mediaQueries from "../../util/mediaqueries";
import { spacing } from "../../util/spacing";
import { Palette } from "../../constants/palettes";
import { NeutralColors } from "../../constants/colors";
import styled from 'styled-components';
import Grid, { GridItem, gridPosition } from "../grid-container/next";
import Text, { SIZE as TEXT_SIZE } from "../typography/text/next";
import Headline, { SIZE as HEADLINE_SIZE } from "../typography/headline/next";
import ActionBar from "../action-bar";
import ModuleContainer from "../module-container";
import ModuleMediaContainer from "../module-media-container";
import { MediaTextLayout } from "./types";
export var MediaTextModuleContainer = styled(ModuleContainer).attrs(function (_ref) {
  var palette = _ref.palette,
    textColor = _ref.textColor,
    backgroundColor = _ref.backgroundColor,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread(_objectSpread({}, props), {}, {
    textColor: textColor || (palette === Palette.Negative ? NeutralColors.White : NeutralColors.Ink),
    backgroundColor: backgroundColor || (palette === Palette.Negative ? NeutralColors.Ink : NeutralColors.White)
  });
}).withConfig({
  componentId: "sc-2z36ty-0"
})(["padding:", ";", " ", " ", ""], spacing(8, 0), mediaQueries.sm(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: ", ";\n  "])), 0)), spacing(9, 0)), mediaQueries.md(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: ", ";\n  "])), 0)), spacing(10, 0)), mediaQueries.xl(_t3 || (_t3 = _(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding: ", ";\n  "])), 0)), spacing(12, 0)));
export var MediaTextGrid = styled(Grid).withConfig({
  componentId: "sc-2z36ty-1"
})(["row-gap:", ";", " ", " ", ";"], spacing(7), mediaQueries.sm(_t4 || (_t4 = _(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    row-gap: ", ";\n  "])), 0)), spacing(8)), mediaQueries.md(_t5 || (_t5 = _(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    row-gap: ", ";\n  "])), 0)), spacing(9)), mediaQueries.xl(_t6 || (_t6 = _(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    row-gap: ", ";\n  "])), 0)), spacing(8)));
var MediaGridPositons = (_MediaGridPositons = {}, _defineProperty2(_MediaGridPositons, MediaTextLayout.MediaLeft, {
  base: gridPosition().fill(),
  sm: gridPosition().pad(2),
  md: gridPosition().start(2).size(5)
}), _defineProperty2(_MediaGridPositons, MediaTextLayout.MediaRight, {
  base: gridPosition().fill(),
  sm: gridPosition().pad(2),
  md: gridPosition().end(-2).size(5)
}), _MediaGridPositons);
export var ContentGridPositions = (_ContentGridPositions = {}, _defineProperty2(_ContentGridPositions, MediaTextLayout.MediaLeft, {
  base: gridPosition().fill(),
  sm: gridPosition().pad(2),
  md: gridPosition().end(-2).size(4)
}), _defineProperty2(_ContentGridPositions, MediaTextLayout.MediaRight, {
  base: gridPosition().fill(),
  sm: gridPosition().pad(2),
  md: gridPosition().start(2).size(4)
}), _ContentGridPositions);
export var MediaContainerGridItem = styled(ModuleMediaContainer).attrs(function (_ref2) {
  var layout = _ref2.layout,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return _objectSpread(_objectSpread({}, props), {}, {
    forwardedAs: GridItem,
    column: MediaGridPositons[layout]
  });
}).withConfig({
  componentId: "sc-2z36ty-2"
})(["margin-top:", ";", ""], spacing(4), mediaQueries.md(_t7 || (_t7 = _(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    margin-top: 0;\n  "]))))));
export var ContentContainerGridItem = styled(GridItem).attrs(function (_ref3) {
  var layout = _ref3.layout,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return _objectSpread(_objectSpread({}, props), {}, {
    column: ContentGridPositions[layout]
  });
}).withConfig({
  componentId: "sc-2z36ty-3"
})(["display:flex;justify-content:center;align-items:center;text-align:center;flex-direction:column;grid-row:1;", ""], mediaQueries.md(_t8 || (_t8 = _(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    text-align: left;\n    align-items: flex-start;\n  "]))))));
export var Eyebrow = styled(Text).attrs({
  size: TEXT_SIZE.XS
}).withConfig({
  componentId: "sc-2z36ty-4"
})(["text-transform:uppercase;margin-bottom:", ";", " ", ""], spacing(3), mediaQueries.md(_t9 || (_t9 = _(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    margin-bottom: ", ";\n  "])), 0)), spacing(2)), mediaQueries.xl(_t10 || (_t10 = _(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    margin-bottom: ", ";\n  "])), 0)), spacing(3)));
export var Title = styled(Headline).attrs({
  forwardedAs: 'h2',
  extraSmallViewportsSize: HEADLINE_SIZE.ONE,
  smallViewportsSize: HEADLINE_SIZE.ONE,
  mediumViewportsSize: HEADLINE_SIZE.TWO,
  largeViewportsSize: HEADLINE_SIZE.THREE
}).withConfig({
  componentId: "sc-2z36ty-5"
})([""]);
export var Body = styled(Text).attrs({
  extraSmallViewportsSize: TEXT_SIZE.S,
  smallViewportsSize: TEXT_SIZE.S,
  mediumViewportsSize: TEXT_SIZE.M,
  largeViewportsSize: TEXT_SIZE.M
}).withConfig({
  componentId: "sc-2z36ty-6"
})(["margin-top:", ";", " ", " > p:first-of-type{margin-top:0;padding-top:0;}> p:last-of-type{margin-bottom:0;padding-bottom:0;}"], spacing(4), mediaQueries.md(_t11 || (_t11 = _(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    margin-top: ", ";\n  "])), 0)), spacing(2)), mediaQueries.xl(_t12 || (_t12 = _(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    margin-top: ", ";\n  "])), 0)), spacing(3)));
export var MediaTextActionBar = styled(ActionBar).withConfig({
  componentId: "sc-2z36ty-7"
})(["margin-top:", ";", " ", ""], spacing(4), mediaQueries.md(_t13 || (_t13 = _(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    margin-top: ", ";\n  "])), 0)), spacing(3)), mediaQueries.xl(_t14 || (_t14 = _(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    margin-top: ", ";\n  "])), 0)), spacing(4)));